import React from 'react';
import Icon from "components/Varios/Icons.js";
import { InputGroup, Input, InputGroupAddon } from 'reactstrap';
import TooltipItem from "components/Varios/Tooltip.js";

const styles = {
    fontFamily: 'sans-serif',
    textAlign: 'center',
    display: 'flex',
};

export default class InputFileUpload3 extends React.Component {
    constructor(props) {
        super(props);
        this.onChange = this.onChange.bind(this);
        this.state = {
            selectedValue: this.props.name,
            selectedFile: null,
            selectedFileName: this.props.value,
            errorFormat: false,
            
        };
        this.fileRef = React.createRef();
        this.handleClick = this.handleClick.bind(this);
    }

    onChange(event, accept) {
            


        if (this.fileRef.current) {
            var allowedExtensions = /(\.pdf)$/i;
            if (!allowedExtensions.exec(this.fileRef.current.value)) {
                // alert('Invalid file type');                
                // this.fileRef.current.value = '';
                //this.setState({ errorFormat: true })
                return false;
            }
            
            else if (event.target.files.length>0) {
                const fileToUpload = event.target.files[0];
                this.setState(
                    { selectedValue: this.state.selectedValue, selectedFile: fileToUpload, selectedFileName: fileToUpload.name, errorFormat: false },
                    (() => { this.props.onChange(this.props.name, fileToUpload) })
                );
            }else if (event.target.files.length=0) {
                const fileToUpload = event.target.files[0];
                this.setState(
                    { selectedValue: this.state.selectedValue, selectedFile: fileToUpload, selectedFileName: "", errorFormat: false },
                    (() => { this.props.onChange(this.props.name, fileToUpload) })
                );
            }
        }

    }
    



    removeFile(f) {
        if (f) {
            this.setState({ selectedValue: this.props.name, selectedFile: null, selectedFileName: this.props.value });
        }
    }

    handleClick() {
        const fileInput = this.fileRef.current;
        fileInput.click();

    }

    handleValuePresentar(stateFile, selectedFileName, placeholder) {
        if (stateFile === undefined) {
            if (selectedFileName) {
                return selectedFileName
            }
            else {
                return placeholder
            }
        }
        else {
            if (stateFile == true) {
                return selectedFileName
            }
            else {

                return placeholder
            }
        }
    }

    



    render() {
        return (
            <React.Fragment>
                <input type="file" accept=".pdf" onChange={(e, accept) => this.onChange(e, accept)} ref={this.fileRef} />

                <label className={"custom-file-upload " + this.props.className} style={{ display: "initial" }} >

                    <InputGroup className="mb-sm-1 mb-md-0 " >


                        {/* //<div className="pt-1" style={{ display: "inline" }}>{this.props.placeholder}</div> */}
                        <Input
                            onClick={() => this.handleClick()}
                            id="inputfile"
                            readOnly
                            type="text"
                            value={this.handleValuePresentar(this.props.stateFile, this.state.selectedFileName, this.props.placeholder)}
                            required={this.props.required ? this.props.required : false}
                            className="mb-0"
                        />



                        <InputGroupAddon addonType="append" style={{ backgroundColor: "#FFFFFF", border: "1px solid #E3E3E3", borderLeft: "none" }} >
                            <Icon kind={this.props.icon} fill='#243165' width={27} height={27} />
                        </InputGroupAddon>



                    </InputGroup>
                    {
                        this.state.errorFormat && <div className='small-error mb-2'>Solo pueden subirse archivos con extensión .pdf</div>

                    }

                    <TooltipItem content={this.props.tooltipmessage !== "" ? this.props.tooltipmessage : "Los archivos se subirán al momendo de dar clic en el botón Guardar"} id="inputfile" />
                </label>
            </React.Fragment>

        );
    }
}
